import { _ as _ts_decorate } from "@swc/helpers/_/_ts_decorate";
import { _ as _ts_metadata } from "@swc/helpers/_/_ts_metadata";
import { observable, runInAction } from "mobx";
class RpmProductVariantToSubscription {
    constructor(data, store){
        this.store = store;
        runInAction(()=>{
            this.data = data;
        });
    }
}
_ts_decorate([
    observable,
    _ts_metadata("design:type", Object)
], RpmProductVariantToSubscription.prototype, "data", void 0);
export { RpmProductVariantToSubscription };
